import { Typography } from '@mui/material'

import { ArtistCreateDmRoomInput } from '@/clients/utoniq-core/schema'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { Head } from '@/components/layouts/Head'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter } from '@/core'
import { CellFrame, Template } from '@/core/architecture'
import { useTranslation } from '@/core/i18n'

import { DmRoomCreateForm } from './DmRoomCreateForm'

// export * from './fragments'

export type State = {
  artistId: string
}

export type Action = {
  onSubmit: (values: ArtistCreateDmRoomInput) => Promise<void>
}

export const ConsoleDmRoomCreateTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { t } = useTranslation('consoleDmRoomCreate')
  const { routerNames } = useRouter()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleDmRooms} />
      <ConsoleBaseLayout
        margin
        header={{
          back: true,
          title: t('title'),
        }}
      >
        <CellFrame sx={{ pt: 2 }}>
          <Typography variant="h3" py={3}>
            {t('title')}
          </Typography>
        </CellFrame>
        <DmRoomCreateForm onSubmit={onSubmit} />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
